// @flow

import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import Group from 'sail/Group';
import Box from 'sail/Box';
import {Subheading} from 'sail/Text';
import {useArticle} from 'docs/data';
import {defineMessages, FormattedMessage} from 'react-intl';

import './RecommendedDocs.scss';

const messages = defineMessages({
  recommendedDocsHeaders: {
    id: 'docsShell.navigation.recommendedDocs',
    description:
      'This is the header for the recommended docs section (experimental)',
    defaultMessage: 'Related Guides',
  },
});

export const RecommendedDocs = () => {
  const {article} = useArticle();

  if (!article.recommendedDocs) {
    return null;
  }

  const validDocs = article.recommendedDocs.filter(
    (element) => element.text && element.link,
  );

  return (
    <Box>
      <Subheading className="RecommendedDocs-header">
        <FormattedMessage {...messages.recommendedDocsHeaders} />
      </Subheading>
      <Group spacing={12}>
        {validDocs.map((recDoc) => (
          <ButtonLink
            key={recDoc.text}
            label={recDoc.text}
            href={recDoc.link}
          />
        ))}
      </Group>
    </Box>
  );
};
